
		import { VisualizationLayer } from './src/visualization.js';
		// Example usage: attach to global for debugging/demo
		window.visualizationLayer = new VisualizationLayer();
		// You can call: window.visualizationLayer.renderNetworkGraph(network) from anywhere
	